/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
document.querySelectorAll('.wp-block-gss-faqs').forEach(faq => {
    faq.querySelectorAll('.wp-block-gss-faq').forEach((question) => {
        
        question.querySelector('button').addEventListener('click', () => {
            if (question.classList.contains('open')) {
                question.classList.remove('open');
                question.querySelector('button').setAttribute('aria-expanded', 'false');
            } else {
                faq.querySelectorAll('.wp-block-gss-faq').forEach(answer => {
                    answer.classList.remove('open');
                    answer.querySelector('button').setAttribute('aria-expanded', 'false');
                });
                question.classList.add('open');
                question.querySelector('button').setAttribute('aria-expanded', 'true');
            }
        })
    })
});